import { i18n } from "@/i18n/i18n.config";
import { ValidationSchemas } from "@/libs/base/constants/validation";
import { z } from "zod";

export const newsletterEmailSchema = z.object({
  email: ValidationSchemas.Email,
});

export const validNewsletterPronouns = ["he/him", "she/her", "they/them"];
export const newsletterNameSchema = z.object({
  firstName: ValidationSchemas.Name,
  lastName: ValidationSchemas.Name,
  pronoun: z
    .string()
    .trim()
    .toLowerCase()
    .refine((value) => validNewsletterPronouns.includes(value), {
      message: `Invalid pronoun. Use one of the following: ${validNewsletterPronouns.join(", ")}`,
    }),
});

const languageSchema = z.object({
  language: z.enum(i18n.locales),
});

const cfTurnstileTokenSchema = z.object({
  cfTurnstileToken: z.string().trim().min(1),
});

export const subscribeNewsletterContractSchema = newsletterEmailSchema
  .merge(newsletterNameSchema)
  .merge(languageSchema);

export const subscribeNewsletterWithCfTokenSchema = subscribeNewsletterContractSchema.merge(cfTurnstileTokenSchema);

export type SubscribeNewsletterContract = z.infer<typeof subscribeNewsletterContractSchema>;

export type SubscribeNewsletterServerContract = z.infer<typeof subscribeNewsletterWithCfTokenSchema>;
